import axios from '@/api/config';

const department = {
  getDepartmentById(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartment/` + data, {});
  },
  getDepartment(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartment`, { params: data });
  },
  getDepartmentList(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentList`, { params: data });
  },
  getNewDepartmentTreeList(data) {
    return axios.get(`${process.env.BASE_URL}/department/getNewDepartmentTreeList`, { params: data });
  },
  getNewDepartmentListByTreeId(data) {
    return axios.get(`${process.env.BASE_URL}/department/getNewDepartmentListByTreeId`, { params: data });
  },
  getDepartmentTree(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentTree`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/department/pageList`, data);
  },
  tableList(data) {
    return axios.get(`${process.env.BASE_URL}/department/tableList`, data);
  },
  addDepartment(data) {
    return axios.post(`${process.env.BASE_URL}/department/addDepartment`, data);
  },
  updateDepartment(data) {
    return axios.post(`${process.env.BASE_URL}/department/updateDepartment`, data);
  },
  deleteDepartment(data) {
    return axios.delete(`${process.env.BASE_URL}/department/deleteDepartment`, { data: data });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/department/exportExcel`, { params: data });
  },
  onDepartment(data) {
    return axios.get(`${process.env.BASE_URL}/department/onDepartment`, { params: data });
  },
  offDepartment(data) {
    return axios.get(`${process.env.BASE_URL}/department/offDepartment`, { params: data });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/department/importData`, data);
  },
}

export default department;



// WEBPACK FOOTER //
// ./src/api/department.js